var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error_message)?_c('p',{staticClass:"error-notification",domProps:{"textContent":_vm._s(_vm.error_message)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }